module.exports = "https://web-assets-production.autolist.com/_next/static/images/impact-43c5ac650d1afc6c125277ce7e4efc82.jpg";